import React, { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippy.js/react';
import { Flex } from 'rebass';
import { FaShopify } from 'react-icons/fa';
import { useIsSideBarClosed } from 'ui/hooks';
import { BiGift } from 'react-icons/bi';
import { ReactComponent as BabyYearbooksLogo } from 'babys-first-year/assets/bfylogo.svg';
import { TopNavBar, TopNavActions, BottomNav, NavAction } from './styled';
import { useMyAllChildJournals, useMyChildJournals } from './hooks';
import { useWindowSize } from 'react-use';
import { useMobileCheckHook } from 'story-media/hooks';
import { TooltipWrap } from 'stories/story-detail-header/styled';
import MeDropdown from 'app/navigation/links/me-dropdown';
import useToggle from 'app/hooks/toggle';
import MemberAvatar from 'members/avatar/index';
import useCurrentMemberId from 'members/hooks/index';
import { CurrentCollectionContext } from 'collections/current-collection-context';

// Storefront links. The dashboard links out to the existing store rather than
// hosting a purchase flow of its own.

const purchaseActions = (onRedeemGift, PURCHASE_URL) => [
  {
    key: 'purchase',
    icon: <FaShopify size={20} />,
    label: 'Purchase',
    onClick: () => window.open(PURCHASE_URL, '_blank', 'noopener'),
  },
  {
    key: 'redeem',
    icon: <BiGift size={20} />,
    label: 'Redeem a Gift',
    onClick: onRedeemGift,
  },
];

// Mobile puts Purchase / Redeem a Gift in a sticky bottom bar; desktop moves them
// to the top-right of the header (see Desktop-Experience.png).
export const DashboardTopNav = ({ onRedeemGift, PURCHASE_URL }) => {
  const { journals } = useMyAllChildJournals();
  const { width, height } = useWindowSize();
  const isFromMobile = useMobileCheckHook()
  const [isTooltipOpen, setTooltipOpen] = useToggle();
  const currentMemberId = useCurrentMemberId();
  const { currentCollection } = useContext(CurrentCollectionContext);
  const wrapper = useRef(null);

  const isSideBarClosed = useIsSideBarClosed();
  const hasInitializedJournal = journals.some((journal) => journal?.state === "initialized");

  return (
    <TopNavBar>
      {hasInitializedJournal ? <div /> : (isSideBarClosed || (!isFromMobile && hasInitializedJournal)) ? <BabyYearbooksLogo width={146} height={20} aria-label="Baby Yearbooks" /> : <div />}
      <TopNavActions>
        {/* {purchaseActions(onRedeemGift, PURCHASE_URL).map(action => (
          <NavAction key={action.key} type="button" onClick={action.onClick}>
            {action.icon}
            {action.label}
          </NavAction>
        ))} */}
        <Tippy
          content={<TooltipWrap ref={wrapper}>
            <MeDropdown
              isFromHeader
              journalId={currentCollection?.id}
              handleClick={setTooltipOpen}
              hasInitializedJournal={hasInitializedJournal}
            />
          </TooltipWrap>}
          interactive
          theme="light"
          trigger="manual"
          visible={isTooltipOpen}
          placement="bottom-end"
        >
          <Flex ml="auto" alignItems="center" onClick={setTooltipOpen}>
            <MemberAvatar size={30} id={currentMemberId} />
          </Flex>
        </Tippy>
      </TopNavActions>
    </TopNavBar>
  )
};

DashboardTopNav.propTypes = {
  onRedeemGift: PropTypes.func.isRequired,
  PURCHASE_URL: PropTypes.string.isRequired,
};

export const DashboardBottomNav = ({ onRedeemGift, PURCHASE_URL }) => (
  <BottomNav>
    {purchaseActions(onRedeemGift, PURCHASE_URL).map(action => (
      <NavAction key={action.key} type="button" onClick={action.onClick}>
        {action.icon}
        {action.label}
      </NavAction>
    ))}
  </BottomNav>
);

DashboardBottomNav.propTypes = {
  onRedeemGift: PropTypes.func.isRequired,
  PURCHASE_URL: PropTypes.string.isRequired,
};
